import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.scss'],
    standalone: false // NOSONAR
}) 
export class HistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    console.info('something')
  }


}
